<template>
  <b-button
    :style="buttonStyle"
    :variant="variant"
    :size="size"
    :type="type"
    :class="buttonClass"
    :disabled="isBusy || disabled"
    @click="$emit('click')"
  >
    <slot>
      {{ text }}
    </slot>
    <Spinner
      :show="isBusy"
      custom-class="ml-2"
    />
  </b-button>
</template>

<script>
import Spinner from '@/view/base/design-system/molecules/Spinner.vue'

export default {
  name: 'SaveButton',
  components: {
    Spinner,
  },
  props: {
    text: {
      type: String,
      default: 'Lưu',
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'sm',
    },
    type: {
      type: String,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: Object,
      default: () => ({
        fontWeight: '600',
        minWidth: '70px',
      }),
    },
    buttonClass: {
      type: String,
      default: 'font-weight-bolder',
    },
  },
}
</script>
